export {type CounterProps, default} from './Counter';
